import * as React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs.tsx";
import RecentEvents from "./recent-events";

export default function NotificationsAndEvents() {
  return (
    <div className="h-full p-2 space-y-4 overflow-auto bg-gray-50/50">
      <Tabs defaultValue="events" className="w-full">
        <TabsList className="grid w-full grid-cols-1">
          <TabsTrigger value="events">Events</TabsTrigger>
        </TabsList>
        
        <TabsContent value="events" className="mt-2">
          <RecentEvents />
        </TabsContent>
      </Tabs>
    </div>
  );
}
